import { render, staticRenderFns } from "./DashboardCurrentUserTodoList.vue?vue&type=template&id=47acc416&"
import script from "./DashboardCurrentUserTodoList.vue?vue&type=script&lang=ts&"
export * from "./DashboardCurrentUserTodoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports